import React, { useEffect, useState, useCallback } from 'react';
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { toast } from 'react-toastify';
import classes from './tabs.module.scss';
import Loader from '../../../../_common/Loader/Loader';
import Pagination from '../../../../_common/Pagination/Pagination';
import { getScriptsRequest } from '../../../../../store/actions/script';
import accountHelpers from '../../../../../utils/accountHelpers';
import { getPhysicianScriptRequest } from '../../../../../store/actions/physicians';
import { useQuery } from '../../../../../utils/hooks/useQuery';
import Button from '../../../../_common/Form/Buttons/Button';
import Api from '../../../../../api/api';

const tableHeader = [
  {
    name: 'Status',
    path: 'status',
  },
  {
    name: 'Date',
    path: 'processedOn',
  },
  {
    name: 'Patient',
    path: 'Patient',
  },
  {
    name: 'Medication',
    path: 'Product.name',
  },
  {
    name: 'Other',
    path: 'other',
  },
];

const Script = ({ type }) => {
  const { physicianId, groupName } = useParams();
  const { query } = useQuery();

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [btnLoading, setBtnLoading] = useState(false);
  const { scriptData, scriptTotalPage, requestStatus } = useSelector((store) => store.script);
  const { physicianScript, physicianScriptTotalPage } = useSelector((store) => store.physicians);

  const initialData = useCallback(() => {
    const data = {
      userId: accountHelpers.getUser().id,
      limit: 15,
      page: 1,
    };

    if (type === 'health') {
      data.healthId = query?.hubId;
    } else {
      data.physicianId = physicianId;
    }

    return data;
  }, []);

  const [requestData, setRequestData] = useState(initialData);
  const [loading, setLoading] = useState(false);
  const [load, setLoad] = useState(true);

  const { limit, page } = requestData;

  useEffect(() => {
    (async () => {
      setLoad(true);

      if (type === 'group') {
        await dispatch(getPhysicianScriptRequest({ physGroup: groupName, userId: accountHelpers.getUser().id }));
      } else {
        await dispatch(getScriptsRequest(requestData));
      }
      setLoad(false);
    })();
  }, [type]);

  const scripts = _.orderBy(
    physicianScript.map((p) => p.Scripts).flat(1),
    (s) => (moment(s.processedOn).isValid() ? moment(s.processedOn).valueOf() : -1),
    'desc',
  );

  const onChangePageData = async (path, count) => {
    setLoading(true);

    const newRequestData = { ...requestData, [path]: count };

    if (path === 'limit') {
      newRequestData.page = 1;
    }

    await dispatch(getScriptsRequest(newRequestData));

    setRequestData(newRequestData);

    setLoading(false);
  };

  const onExportClick = async () => {
    setBtnLoading(true);
    try {
      await Api.getScripts({ ...requestData, download: true });
      toast.success('The file will be generated in background and will be sent you via email');
    } catch (e) {
      toast.error('Something wrong try again');
    }
    setBtnLoading(false);
  };

  const physicianScripts = type === 'group' ? scripts : scriptData;

  return (
    (!loading && requestStatus === 'request') || load ? <Loader className={classes.loader} />
      : (requestStatus === 'success' && !physicianScripts.length)
        ? <div className={classes.notResult}>No Data Found</div>
        : (
          <>
            {accountHelpers.getUser().role === 'Health' && (
            <Button
              title="Export"
              onClick={onExportClick}
              loading={btnLoading}
            />
            )}

            <div className={classes.table_wrapper}>

              { loading && <Loader />}

              <table>

                <thead>
                  <tr>
                    {tableHeader.map((h) => (
                      <th key={h.name}>{h.name}</th>
                    ))}
                  </tr>
                </thead>

                <tbody>
                  {physicianScripts.map((s) => (
                    <tr key={s.id} onClick={() => navigate(`/scripts/${s.id}`)}>
                      {tableHeader.map((h) => (
                        h.path === 'Patient'
                          ? <td key={h.name}>{`${s[h.path]?.firstName} ${s[h.path]?.lastName} `}</td>
                          : h.path === 'processedOn'
                            ? (
                              <td key={h.name}>
                                {moment(s[h.path]).isValid()
                                  ? moment(s[h.path]).format('MM/DD/YYYY')
                                  : '-'}
                              </td>
                            )
                            : <td key={h.name}>{_.get(s, h.path) || '-'}</td>
                      ))}

                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {type !== 'group' && (
              <Pagination
                page={+page - 1}
                limit={limit}
                totalPage={type ? +physicianScriptTotalPage : +scriptTotalPage}
                onChange={onChangePageData}
                showLimit
              />
            )}
          </>
        )

  );
};

Script.propTypes = {
  type: PropTypes.string,
};

Script.defaultProps = {
  type: '',
};

export default Script;
